<template>
    <div class="
        grid grid-cols-12 col-span-4 col-start-1 mt-20 mb-10 gap-y-8
        sm:col-span-10 sm:col-start-2 sm:gap-x-11 sm:gap-y-20
        md:col-span-12 md:gap-x-5 md:mb-0 md:gap-y-16
        lg:gap-x-7 lg:mb-10 lg:gap-y-24
        xxl:mb-24 xxl:mt-36 xxl:col-span-12 xxl:gap-x-10 xxl:gap-y-32
    ">
        <a class="
            fade-in col-span-12 border-cream border-b pb-8 grid grid-cols-2 gap-x-5 items-start
            sm:flex-col sm:col-span-4 sm:border-0 sm:pb-0 sm:flex
            md:col-span-3
        "
            :href="post.link"
            v-for="post in posts"
            :key="post.id"
        >
            <div class="relative overflow-hidden rounded-fix rounded-md sm:w-full sm:rounded-[14px] sm:mb-3.5 md:mb-4 lg:mb-5 xxl:mb-8">
                <div class="pb-[100%]"></div>
                <!-- <img class="absolute left-0 top-0 w-full h-full object-cover object-center" :src="post.image.sizes.large" :alt="post.image.alt" v-if="post.image && !post.media_type"> -->
                <ImageBG :image="post.image" class="absolute left-0 top-0 w-full h-full object-cover object-center" v-if="post.image && !post.media_type"></ImageBG>
                <video v-else muted playsinline autoplay loop :src="post.video" class="absolute left-0 top-0 w-full h-full object-cover object-center"></video>
            </div>

            <div class="sm:w-full">
                <div class="flex flex-wrap">
                    <div 
                        class="label mb-5 mr-2 sm:mb-7" 
                        :class="{'label--yellow' : type.slug === 'dojo', 'label--blue' : type.slug !== 'dojo'}"
                        v-for="type in post.types"
                        :key="type.id"
                        v-html="type.name"
                    ></div>
                </div>

                <h4 class="text-24 mb-4 sm:text-20 sm:mb-3.5 md:mb-4 lg:text-28 lg:mb-5 xxl:text-30 xxl:mb-6" v-html="post.title"></h4>

                <p class="text-16 sm:text-13 lg:text-16 xxl:text-base" v-html="dateFormat(post.interval_dates)"></p>
                <p class="text-16 sm:text-13 lg:text-16 xxl:text-base" v-html="post.type === 'normal' ?  post.normal_dates.description : post.reccuring_data.date_description"></p>
                
            </div>

        </a>
    </div>
</template>

<script>
import ImageBG from './imageBG.vue'
import moment from 'moment';

const INPUT_DATE_FORMAT = 'DD-MM-YYYY';

export default {
    data() {
        return {
            isLoaded: false,
        }
    },

    props: {
        posts: Array,
        today: Date
    },

    mounted() {
        this.isLoaded = true;
    },

    methods: {
        dateFormat(date) {
            // for (let index = 0; index < date.length; index++) {
            //     if ( this.today <= date[index] ) {
            //         // console.log(date[index])
            //     }
            //     // const element = array[index];
                
            // }

            let today = moment(this.today).format('YYYY-MM-DD');

            let dates = date.filter(item => {
                if ( moment(item).isSameOrAfter(today) ) {
                    return item;
                }
            }).sort((x, y) => {
                return x.diff(y)
            });

            // console.log(moment(this.today).format('YYYY-MM-DD'));
            
            return moment(dates[0]).format('MMM DD, YYYY');

            // let nearestStart = date.find((x) => {
            //     return x.isSameOrAfter(this.today);
            // });

            // console.log(nearestStart)
            // console.log(this.today)
            // console.log(date);
        //    return moment(date).format('MMM DD, YYYY');
        },
        printDate(d) {
            const initDate = d.split('-'),
                currentDate = new Date(initDate[2], initDate[1] - 1, initDate[0]),
                day = new Intl.DateTimeFormat('en', {
                    day: 'numeric'
                }).format(currentDate),
                month = new Intl.DateTimeFormat('en', {
                    month: 'short'
                }).format(currentDate);

            return `${day} ${month}`;
        },

        printYearDate(d) {
            const initDate = d.split('-'),
                currentDate = new Date(initDate[0], initDate[1], initDate[2]),
                day = new Intl.DateTimeFormat('en', {
                    day: 'numeric'
                }).format(currentDate),
                month = new Intl.DateTimeFormat('en', {
                    month: 'short'
                }).format(currentDate),
                year = new Intl.DateTimeFormat('en', {
                    year: 'numeric'
                }).format(currentDate);

            return `${day} ${month}<br class="hidden | lg:inline">${year}`;
        }
    },
    components: {
        ImageBG
    },
}
</script>

<style scoped lang="scss">
    .fade-in {
        animation: fade-in .67s ease;
    }
    
    @keyframes fade-in {
        from {
            @apply opacity-0;
        }
        to {
            @apply opacity-100
        }
    }
</style>